import { PATIENT_GENDER_LABELS } from '@/constants/patient';
import { formatCpfDisplay } from '@/utils/participantDetailDisplay';
import { buildSummaryFromSession } from './prontuarioPatientSummary';

export type ProntuarioProfileHeroMeta = {
	cpf: string | null;
	gender: string | null;
};

export const resolveProntuarioProfileHeroMeta = (
	patient?: Patients.Patient | null,
	user?: Users.User | null,
	session?: Sessions.Session | null,
): ProntuarioProfileHeroMeta => {
	if (patient) {
		return {
			cpf: formatCpfDisplay(patient.cpf),
			gender: patient.gender
				? PATIENT_GENDER_LABELS[patient.gender]
				: null,
		};
	}

	if (user) {
		return {
			cpf: formatCpfDisplay(user.cpf),
			gender: null,
		};
	}

	const summary = buildSummaryFromSession(session);

	return {
		cpf: null,
		gender: summary.gender !== '—' ? summary.gender : null,
	};
};
